import { Formik } from 'formik';
import React, { useState } from 'react'
import CustomInputField from '../../../../common/CustomInputField';

function CompanyStaffForm() {
    const initialValues = {
        from: '',
        to: '',

    }

    const validate = (values) => {
        let errors = {};

        if (!values.from) {
            errors.from = "From Date is required";
        }
        if (!values.to) {
            errors.to = "To Date is required";
        }

        return errors;
    };

    const submitForm = (values) => {
        console.log(values);
    };

    const changeHandle = (selectedData) => {
        // TODO
    };

    return (
        <>
            <div className="row m-4">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0"><b>COMPANY STAFF </b></h4>
                                </div>
                                <Formik
                                    initialValues={initialValues}
                                    validate={validate}
                                    onSubmit={submitForm}

                                >
                                    {(formik) => {
                                        const {
                                            values,
                                            handleChange,
                                            handleSubmit,
                                            errors,
                                            touched,
                                            handleBlur,
                                            isValid,
                                            dirty,
                                        } = formik;
                                        return (
                                            <form className="tbl-captionn">
                                                <div className="row">
                                                    <div className="col-xl-4 mb-3">
                                                        <label htmlFor="exampleFormControlInput1" className="form-label">From <span className="text-danger">*</span></label>
                                                        <CustomInputField
                                                            type="date"
                                                            value={values.from}
                                                            hasError={errors.from && touched.from}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.from}
                                                            autoFocus={true}
                                                            id="from"
                                                            name="from"
                                                        // placeholder="From"
                                                        />
                                                    </div>
                                                    <div className="col-xl-4 mb-3">
                                                        <label htmlFor="exampleFormControlInput2" className="form-label">To<span className="text-danger">*</span></label>
                                                        <CustomInputField
                                                            type="date"
                                                            value={values.to}
                                                            hasError={errors.to && touched.to}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.to}
                                                            autoFocus={true}
                                                            id="to"
                                                            name="to"
                                                        // placeholder="To"
                                                        />
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 mg-t-10 mg-sm-t-25">
                                                        <label className="form-label"></label>
                                                        <br />
                                                        <button className="btn btn-primary pd-x-20 rounded-0 mt-3" type="submit"><i className="fas fa-search"></i> Search</button>
                                                        {/* <button className="btn btn-danger pd-x-20" type="button" data-toggle="modal" data-target="#transaction_download_model" onClick={()=>setModalShow(true)}>
                                                <FaDownload /> Download
                                            </button> */}
                                                    </div>

                                                </div>
                                            </form>
                                        );
                                    }}
                                </Formik>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default CompanyStaffForm
